jQuery(document).ready(function($) {

      if ( $('.filterseancesvendredi_filter').length ) {

        $("#multi_s_year .multiselect-dropdown-list > div.checked").each(function () {
                console.log($(this).find('label').html());
                var selected_y = $(this).find('label').html();

                 $("#multi_s_month .multiselect-dropdown-list > div.checked").each(function () {
                     console.log($(this).find('label').html());
                     var selected_m = $(this).find('label').html();

                    $(".s_"+selected_y+".s_"+selected_m).removeClass('hidden'); 
                
                });  
        });  

        $('.filterseancesvendredi_submit').click(function(e){
            e.preventDefault();
            $('.seance_vendredi_item').addClass('hidden');
            $("#multi_s_year .multiselect-dropdown-list > div.checked").each(function () {
                console.log($(this).find('label').html());
                var selected_y = $(this).find('label').html();

                 $("#multi_s_month .multiselect-dropdown-list > div.checked").each(function () {
                     console.log($(this).find('label').html());
                     var selected_m = $(this).find('label').html();

                    $(".s_"+selected_y+".s_"+selected_m).removeClass('hidden'); 
                
                });  
            });  
        }); 
    } 
});